<template>
    <Dialog v-model:visible="isShowInfo" id="attributes_dialog" class="login_dialog" header="Реєстрація" modal :style="{ width: '500px' }">
        <p>Для реєстрації зверніться до Вашого регіонального менеджера, або у наш відділ супроводу клієнтів:</p>
        <div class="contacts">
            <a>info@vector-vs.com</a>
            <a href="tel:+38 (044) 369-51-57">+38 (044) 369-51-57</a>
            <a href="tel:+38 (067) 193-55-04">+38 (067) 193-55-04</a>
        </div>
        <template #footer>
            <div class="confirm_buttons">
                <a href="#" class="confirm_button_confirm" @click.prevent="isShowInfo=false">ОК</a>
            </div>
        </template>
    </Dialog>

    <AppCommonTopbar @menu-toggle="onMenuToggle"/>

    <Head title="Log in" />

    <MinimalLayout title="">
        <template #content>
            <h2>Авторизація</h2>
            <div class="fluid">
                <div class="field">
                    <label for="email">
                        Електронна пошта
                    </label>
                    <InputText id="email"
                               v-model="form.email"
                               placeholder="Введіть Email"
                               type="email"
                               required="true"
                               :class="{'p-invalid': form.errors.email || errors}"
                               @keyup.enter="submit"
                    />
                    <small v-if="form.errors.email" class="p-invalid">
                        {{ form.errors.email }}
                    </small>
                </div>
                <div class="field">
                    <label for="password">
                        Пароль
                    </label>
                    <div class="pass_container">
                        <InputText id="password_input"
                                v-model="form.password"
                                required="true"
                                type="password"
                                    placeholder="Введіть Пароль"
                                autocomplete="current-password"
                                @keyup.enter="submit"
                                :class="{'p-invalid': form.errors.password || errors}"
                        />
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-on:click="showPassword()">
                        <path d="M8 3.41663C4.36364 3.41663 1.25818 5.67844 0 8.87117C1.25818 12.0639 4.36364 14.3257 8 14.3257C11.6364 14.3257 14.7418 12.0639 16 8.87117C14.7418 5.67844 11.6364 3.41663 8 3.41663ZM8 12.5075C5.99273 12.5075 4.36364 10.8784 4.36364 8.87117C4.36364 6.8639 5.99273 5.23481 8 5.23481C10.0073 5.23481 11.6364 6.8639 11.6364 8.87117C11.6364 10.8784 10.0073 12.5075 8 12.5075ZM8 6.68935C6.79273 6.68935 5.81818 7.6639 5.81818 8.87117C5.81818 10.0784 6.79273 11.053 8 11.053C9.20727 11.053 10.1818 10.0784 10.1818 8.87117C10.1818 7.6639 9.20727 6.68935 8 6.68935Z" fill="#6C757D"/>
                        </svg>
                    </div>

                    <small v-if="form.errors.password" class="p-invalid">
                        {{ form.errors.password }}
                    </small>
                </div>
                <div v-if="errors && errors.msg" class="error-msg">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.5ZM8.75 11.75H7.25V10.25H8.75V11.75ZM8.75 8.75H7.25V4.25H8.75V8.75Z" fill="#B70D09"/>
                    </svg>
                    {{ errors.msg  }}
                </div>
                <div class="field field_row">
                    <label class="toggle">
                        <input class="toggle__checkbox" type="checkbox" v-model="form.remember">
                        <span class="toggle__switch"></span>
                        <span class="title">Запам’ятати мене</span>
                    </label>
                    <a href="/register">Реєстрація</a>
                </div>
                <div class="field">
                    <Button label="Увійти"
                            type="submit"
                            @click="submit"
                            :loading="form.processing"
                    />
                </div>
            </div>
        </template>
    </MinimalLayout>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3';
import MinimalLayout from "../../Layouts/MinimalLayout";
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import AppCommonTopbar from "@/Components/AppCommonTopbar";
import Dialog from "primevue/dialog";

export default {
    components: {
        AppCommonTopbar,
        MinimalLayout,
        Head,
        Link,
        Button,
        InputText,
        Dialog
    },

    props: {
        canResetPassword: Boolean,
        status: String
    },

    data() {
        return {
            isShowInfo: false,
            layoutMode: 'static',
            layoutColorMode: 'light',
            staticMenuInactive: true,
            overlayMenuActive: false,
            mobileMenuActive: false,
            menu: [
                {
                    label: 'Навигация',
                    items: [
                        // {label: 'Главная', icon: 'pi pi-fw pi-home', to: this.route('dashboard'), prefix: 'dashboard', allowedRoles: []},
                        {label: 'Пользователи', icon: 'pi pi-fw pi-user', to: this.route('users.index'),allowedRoles: ['admin']},
                        {label: 'Загрузка БД', icon: 'pi pi-fw pi-upload', to: this.route('upload'),allowedRoles: ['admin']},
                        {label: 'Калькулятор', icon: 'pi pi-fw pi-table', to: this.route('cross-reference'),allowedRoles: []},
                        {label: 'Конфигуратор КРМ', icon: 'pi pi-fw pi-table', to: this.route('krm'),allowedRoles: []},
                        {
                            label: 'Выйти', icon: 'pi pi-fw pi-sign-out', command: () => {
                                this.$inertia.post(this.route('logout'))
                            },
                        }]
                },
            ],
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false
            }),
            errors: null
        }
    },

    mounted() {
        if (this.getCookie('login_email') && this.getCookie('login_pass')) {
            this.form.remember = true;
            this.form.email = this.getCookie('login_email');
            this.form.password = this.getCookie('login_pass');
        }
    },

    methods: {
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
                    if (this.mobileMenuActive === true) {
                        this.overlayMenuActive = true;
                    }

                    this.overlayMenuActive = !this.overlayMenuActive;
                    this.mobileMenuActive = false;
                } else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            } else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        showPassword() {
            var x = document.getElementById("password_input");
            if (x.type === "password") {
                x.type = "text";
            } else {
                x.type = "password";
            }
        },
        submit() {
            this.errors = null
            this.form
                .transform(data => ({
                    ... data,
                    remember: this.form.remember ? 'on' : ''
                }))
                .post(this.route('login'), {
                    onError: (errors) => {
                        this.errors = errors; // Handle server-side validation errors
                    },
                    onFinish: () => {
                        this.form.reset('password');
                    },
                })
        },

        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    }
}
</script>

<style scoped>
.p-button {
    background: #356EEF;
}
h2 {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    display: flex;
    align-items: center;
    color: #000000;
}
label {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.pass_container {
    position: relative;
}

.pass_container svg {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
}
.toggle {
	 cursor: pointer;
	 display: inline-block;
}
 .toggle__switch {
	 display: inline-block;
	 background: #FFFFFF;
    border: 1.25px solid rgba(0, 0, 0, 0.15);
    border-radius: 20px;
	 width: 40px;
	 height: 20px;
	 position: relative;
	 vertical-align: middle;
	 transition: background 0.25s;
     margin-right: 20px;
}
 .toggle__switch:before, .toggle__switch:after {
	 content: '';
}
 .toggle__switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 25%);
    width: 15px;
    height: 14px;
    position: absolute;
    top: 2px;
    left: 2px;
    transition: left 0.25s;
}
 .toggle:hover .toggle__switch:before {
	 background: linear-gradient(to bottom, #fff 0%, #fff 100%);
	 box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}
 .toggle__checkbox:checked + .toggle__switch {
	 background: #0D6EFD;
}
 .toggle__checkbox:checked + .toggle__switch:before {
	 left: 21px;
}
 .toggle__checkbox {
	 position: absolute;
	 visibility: hidden;
}
 .toggle__label {
	 margin-left: 5px;
	 position: relative;
	 top: 2px;
}
.toggle span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}
.contacts {
    display: flex;
    flex-direction: column;
    gap: 5px;
}
.field_row {
    display: flex;
    justify-content: space-between;
}
.confirm_button_confirm {
    font-size: 16px;
}
.error-msg {
    display: flex;
    align-items: center;
    gap: 7.5px;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: #B70D09;
    margin-bottom: 1rem;
}
.p-invalid {
    color: #B70D09;
}
</style>
